"use client"
import React from "react"
import classes from "./footer.module.scss"
import { useRouter } from "next/navigation"

 const Footer = () => {
    const router = useRouter()

  return  (
    <div className={classes.footerWrapper}>
<div  className={classes.subscribeText}>Subscribe to our newsletter to receive more interesting stories</div>
<div  className={classes.subscribeButton} onClick={()=>{router.push('/Brightr-Subscription/subscribe')}}> Get started</div>
    </div>
  ) 
}

export default Footer
